import React, { useEffect } from 'react';

import { useDispatch } from 'react-redux';

import { resetAllSteps } from 'actions/stages';
import FormHeader from 'components/FormHeader';
import styles from 'pages/NotQualified/NotQualified.module.scss';
import { InfoIcon } from 'assets/images';

const NotQualified = () => {
  const dispatch = useDispatch();

  useEffect(() => {
    return () => {
      dispatch(resetAllSteps());
    };
  });

  return (
    <>
      <FormHeader>
        <div className={styles.headerContainer}>
          <h1 className={styles.title}>Unfortunately, you do not qualify based on the information you provided.</h1>
          <InfoIcon className={styles.infoIcon} />
        </div>
      </FormHeader>
    </>
  );
};

export default NotQualified;
